import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-216">
      <div className="max-w-3xl mx-auto" data-id="element-217">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-218">
          El resultado para vos como docente
        </h2>

        <p className="text-xl mb-4 font-medium text-center" data-id="element-219">
          Con este pack vas a lograr:
        </p>

        <div className="bg-green-50 rounded-2xl p-5 border border-green-200 mb-4" data-id="element-220">
          <ul className="space-y-2 text-xl font-bold text-gray-800" data-id="element-221">
            <li className="flex items-start" data-id="element-222">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-223" />
              <span data-id="element-224">ahorrar horas de preparación</span>
            </li>
            <li className="flex items-start" data-id="element-225">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-226" />
              <span data-id="element-227">tener todo organizado durante el año</span>
            </li>
            <li className="flex items-start" data-id="element-228">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-229" />
              <span data-id="element-230">trabajar efemérides de forma clara</span>
            </li>
            <li className="flex items-start" data-id="element-231">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-232" />
              <span data-id="element-233">destacarte con actividades diferentes</span>
            </li>
            <li className="flex items-start" data-id="element-234">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-235" />
              <span data-id="element-236">preparar actos escolares con mayor seguridad</span>
            </li>
          </ul>
        </div>

        <p className="text-2xl font-black text-center text-gray-900" data-id="element-237">
          <span className="bg-yellow-300/50 px-2" data-id="element-238">
            Todo sin perder tiempo buscando material en internet.
          </span>
        </p>
      </div>
    </section>;
}